export default __webpack_public_path__ + "static/media/closeicon.7c5e43d4.svg";